import { createStore } from 'vuex'
import axios from 'axios'

import {router} from "../main.js"

var toolstate = {};
var orderSystem = 0;
var mailFunctions = 0;
var hasDiscounts = 0;
var client = {}
var order = {}
var cart = [];
var discountList = [];

var curLanguage = "en";
var curCurrency = "euro";
var curSelectedMake = "";
var curSelectedModel = "";
var curSelectedVariant = "";

var curMakes = "";
var curModels = "";
var curVariants = "";
var clientIP = "";

var logoLinkout= "https://rica.nl";
var hostDomain= "tool.rica.nl";

if(localStorage.getItem('toolstate') != null) {
  toolstate = JSON.parse(localStorage.getItem('toolstate'))
  curLanguage = toolstate["curLanguage"]
  curCurrency = toolstate["curCurrency"]
  curSelectedMake = toolstate["curSelectedMake"]
  curSelectedModel = toolstate["curSelectedModel"]
  curSelectedVariant = toolstate["curSelectedVariant"]
  curMakes = toolstate["curMakes"]
  curModels = toolstate["curModels"]
  curVariants = toolstate["curVariants"]  
  orderSystem = toolstate["orderSystem"]
  mailFunctions = toolstate["mailFunctions"]
  clientIP = toolstate["clientIP"]
  logoLinkout = toolstate["logoLinkout"]
  hostDomain = toolstate["hostDomain"]
  discountList = toolstate["discountList"]
  

} 

if(localStorage.getItem('cart') != null) {
  cart = JSON.parse(localStorage.getItem('cart'))
}

if(localStorage.getItem('client') != null) {
  client = JSON.parse(localStorage.getItem('client'))
} 


if(localStorage.getItem('order') != null) {
  order = JSON.parse(localStorage.getItem('order'))
} 




export default createStore({
  state: {
    api_url: process.env.VUE_APP_RICA_API_HOST,
    cdn_url: process.env.VUE_APP_RICA_API_CDN_HOST,
    orderSystem: orderSystem,
    mailFunctions:mailFunctions,
    hasDiscounts:hasDiscounts,
    curLanguage: curLanguage,
    curCurrency: curCurrency,
    curMakes: curMakes,
    curModels: curModels,
    curVariants: curVariants,
    curTuningProducts: [],
    curSelectedMake: curSelectedMake,
    curSelectedModel: curSelectedModel,
    curSelectedVariant: curSelectedVariant,
    curSelectedProduct: "",
    curTuningResult: null,
    curClient: client,
    clientIP: clientIP,
    shoppingCart: cart,
    curOrder: order,
    authenticated: false,
    curSession: null,
    router: router,
    discountList: discountList,
    logoLinkout:logoLinkout,
    hostDomain:hostDomain
  },
  mutations: {

    setCurSession(state,session) {
      state.curSession = session
    },
    setCurSession(state,session) {
      state.curSession = session
    },
    setClientIP(state,ip) {
      state.clientIP = ip
    },    
    setCurClient(state,client) {
      state.curClient = client
    },
    setOrderSystem(state,os) {
      state.orderSystem = os
      this.commit("updateToolState")        
    },
    setMailFunctions(state,os) {
      state.mailFunctions = os
      this.commit("updateToolState")        
    },
    

    setDiscountList(state,lst) {
      state.discountList = lst
      this.commit("updateToolState")           
    },
    setCurLanguage(state,lang) {
      state.curLanguage = lang
      this.commit("updateToolState")        
    },
    setCurCurrency(state,curr) {
      state.curCurrency = curr
      this.commit("updateToolState")        
    },    
    setCurMakes(state,makes) {
      state.curMakes = makes
    },
    setCurModels(state,models) {
      state.curModels = models
    },
    setCurVariants(state,variants) {
      state.curVariants = variants
      this.commit("updateToolState")    
    },
    setCurTuningResult(state,result) {
      state.curTuningResult = result
    },
    setCurTuningProducts(state,result) {
      state.curTuningProducts = result
    },    
    setCurSelectedMake(state,make) {
      state.curSelectedMake = make
    },    
    setCurSelectedModel(state,model) {
      state.curSelectedModel = model
      this.commit("updateToolState")      
    },    
    setCurSelectedVariant(state,variant) {
      state.curSelectedVariant = variant;
      this.commit("updateToolState")
    },    
    setCurSelectedProduct(state,product) {
      if(product != undefined) {
        state.curSelectedProduct = product
        this.commit("updateToolState")
      }
    }, 
    setCurSelectedProductID(state,productID) {

      state.curSelectedProductID = productID
      this.commit("updateToolState")      
    },     
    addProduct(state,product) {
      state.shoppingCart.push(product) 
      localStorage.setItem('cart', JSON.stringify(state.shoppingCart));
    },    
    removeProduct(state,product) {
      var curCart = JSON.parse(localStorage.getItem('cart'));      
      for(var i=0 ; i < curCart.length ; i++) {
        var curPID = curCart[i].ProductID;
        if(curPID == product) {
          curCart.splice(i,1);
          state.shoppingCart = curCart;
          // localStorage.setItem('cart', JSON.stringify(curCart));
          // this.setShoppingCart(curCart);
          this.commit("setShoppingCart", curCart);
          if(curCart.length < 1) {
            // removeOrderID
            this.commit("removeOrderID")

          }
        }
      }
    },
    removeProductNumber(state,num) {
      var curCart = JSON.parse(localStorage.getItem('cart'));      
   
          curCart.splice(num,1);
          state.shoppingCart = curCart;
          // localStorage.setItem('cart', JSON.stringify(curCart));
          // this.setShoppingCart(curCart);
          this.commit("setShoppingCart", curCart);
          if(curCart.length < 1) {
            // removeOrderID
            this.commit("removeOrderID")

          }
        
      
    },      
    setShoppingCart(state,cart) {
      state.shoppingCart = cart
      localStorage.setItem('cart', JSON.stringify(cart));
    },
    emptyShoppingCart(state) {
      var emptyCart = [];
      state.shoppingCart = emptyCart 
      localStorage.setItem('cart', JSON.stringify(emptyCart));
    },            
    updateToolState(state) {
      var toolstate = {};
      toolstate["curLanguage"] = state.curLanguage;
      toolstate["orderSystem"] = state.orderSystem;
      toolstate["mailFunctions"] = state.mailFunctions;
      
      toolstate["curCurrency"] = state.curCurrency;      
      toolstate["curSelectedMake"] = state.curSelectedMake;
      toolstate["curSelectedModel"] = state.curSelectedModel;
      toolstate["curSelectedVariant"] = state.curSelectedVariant;
      toolstate["curSelectedProduct"] = state.curSelectedProduct;
      toolstate["curSelectedProductID"] = state.curSelectedProductID;
      toolstate["curTuningResult"] = state.curTuningResult;
      
      toolstate["curMakes"] = state.curMakes;
      toolstate["curModels"] = state.curModels;
      toolstate["curVariants"] = state.curVariants;
      toolstate["curTuningProducts"] = state.curTuningProducts;
      toolstate["clientIP"] = state.clientIP;
      toolstate["logoLinkout"] = state.logoLinkout;
      toolstate["hostDomain"] = state.hostDomain;
      toolstate["discountList"] = state.discountList;

      




      localStorage.setItem('toolstate', JSON.stringify(toolstate));
    },    
    saveOrderDetails(state,details) {
      state.curOrder = details 
      localStorage.setItem('order', JSON.stringify(state.curOrder));
    },    
    updateOrderDetails(state,details) {
      var currentOrder = JSON.parse(localStorage.getItem('order'));
      currentOrder["orderid"] = details["orderid"];
      currentOrder["cart_total"] = details["cart_total"];
      currentOrder["cart"] = state.shoppingCart;
      
      state.curOrder = currentOrder; 
      localStorage.setItem('order', JSON.stringify(state.curOrder));
    },    
    cancelOrder(state) {
      this.commit("emptyShoppingCart");
      this.commit("removeOrderID");
    },    
    removeOrderID(state) {
      var currentOrder = JSON.parse(localStorage.getItem('order'));
      // currentOrder["orderid"] = details["orderid"];
      delete currentOrder["orderid"];
      state.curOrder = currentOrder; 
      localStorage.setItem('order', JSON.stringify(state.curOrder));
    },
    setLogoLinkout(state,url) {
      state.logoLinkout = url
      this.commit("updateToolState")    
    },
    setHostDomain(state,domain) {
      state.hostDomain = domain
      this.commit("updateToolState")    
    },
    
    reset(state) {
      var toolstate = {};

      state.curSelectedMake = "";
      state.curSelectedModel = "";
      state.curSelectedVariant = "";
      state.curSelectedProduct = "";
      state.curSelectedProductID = "";
      state.curTuningResult = "";
      state.curMakes = "";
      state.curModels = "";
      state.curVariants = "";
      state.curTuningProducts = "";
      // this.updateToolState()
      this.commit("updateToolState")        
 
      // toolstate["curSelectedMake"] = "";
      // toolstate["curSelectedModel"] =  "";
      // toolstate["curSelectedVariant"] = "";
      // toolstate["curSelectedProduct"] = "";
      // toolstate["curSelectedProductID"] = "";
      // toolstate["curTuningResult"] = "";
      
      // toolstate["curMakes"] = "";
      // toolstate["curModels"] = "";
      // toolstate["curVariants"] = "";
      // toolstate["curTuningProducts"] = "";

      // localStorage.setItem('toolstate', JSON.stringify(toolstate));
    },   
    
  },
  actions: {

    apiRequest(state, options) {

          // axios('https://www.random.org/integers/?num=1&min=1&max=6&format=plain&col=1&base=10')
          axios(options)
      
          .then(response => {
          this.state.router.push({path: options.callback})
          })
    
          .catch(function (error) {
            // handle error
            console.log(error);
          })
          .then(function () {
              // always executed
          });
    },

    login({state, dispatch }, {username, password}) {

      const headers =  {
         'x-api-token': state.curSession
      };
      var loginForm = new FormData();
          loginForm.append('ep','login');
          loginForm.append('username',username);
          loginForm.append('password',password);
      const options = {
        url:  process.env.VUE_APP_RICA_API_HOST + '?ep=login',
        method: 'POST',
        data: loginForm,
        headers: headers,
        callback: '/'
      }

      dispatch('apiRequest', options) 

    } ,

    logout() {
      this.commit('setCurSession', null)
      this.state.router.push({path: '/login'})
    }
  },
  modules: {
  }
})